import React from 'react';
import { Card, CardContent, CardMedia, Alert, Box } from '@mui/material';
import example from '../image.png';

export const InvalidClinicLink: React.FC = () => {
  return (
    <Card sx={{ my: 3 }}>
      <CardMedia component="img" image={example} alt="Invalid clinic link" />
      <Box sx={{ borderBottom: '1px solid #e0e0e0', my: 1 }} />
      <CardContent>
        <Alert severity="error" sx={{ mb: 2 }}>
          Invalid Clinic Link!
        </Alert>
        <p>
          The link you have entered is not a valid clinic link. Your clinic may have a custom landing page configured. Please go to the top of your webpage and copy the dashboard web address (URL), then paste this into the clinic link field.
        </p>
      </CardContent>
    </Card>
  );
};

export default InvalidClinicLink;
